import { env } from "$env/dynamic/public";

const environment = env.PUBLIC_ENVIRONMENT;

let API_BASE_URL;
switch (environment) {
    case "staging":
        API_BASE_URL = "https://staging-api.microdoc.io";
        break;
    case "production":
        API_BASE_URL = "https://api.microdoc.io";
        break;
    default:
        API_BASE_URL = "http://localhost:8000";
}

let FRONTEND_BASE_URL;
switch (environment) {
    case "staging":
        FRONTEND_BASE_URL = "http://34.246.220.123";
        break;
    case "production":
        FRONTEND_BASE_URL = "http://52.30.115.247";
        break;
    default:
        FRONTEND_BASE_URL = "http://localhost";
}

export { API_BASE_URL, FRONTEND_BASE_URL };

export const updateUrl = `${API_BASE_URL}/transcription/update`;
export const updateUrlReport = `${API_BASE_URL}/report/change/update/`;
